import t from '@jetshop/intl';
import React from 'react';
import styled from 'react-emotion';
import { Price } from '../Price';
import Button from '../ui/Button';
import StockStatusIndicator from './StockStatus/StockStatusIndicator';

const Wrapper = styled('div')`
  border: 1px solid ${({ theme }) => theme.colors.greys[8]};
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  width: 100%;
  background: #f8f8f8;
  border-radius: 4px;
  margin-bottom: 2.5rem;
`;

const StockStatus = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 50%;
  flex: 1 auto;
  margin-bottom: 1rem;
  align-self: flex-start;
  margin-top: 0.3rem;
`;

const StockStatusText = styled('div')`
  max-width: 70%;
`;

const StyledButton = styled(Button)`
  font-size: 1.25rem;
  background: ${({ theme }) => theme.colors.checkoutButton.background};
  font-weight: ${({ theme }) => theme.typo.fontWeightBold};
`;

const BuyArea = ({ stockStatus, quantity, ...price }) => (
  <Wrapper>
    <StockStatus>
      <StockStatusIndicator status={stockStatus.status} />
      <StockStatusText>{stockStatus.text}</StockStatusText>
    </StockStatus>
    <Price {...price} />
    <StyledButton data-testid="add-to-cart" type="submit">
      {t('Add to cart')}
    </StyledButton>
  </Wrapper>
);

export default BuyArea;
